import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import icons from '../../../utils/icons';

class Icon extends React.Component {
  static propTypes = {
    name: PropTypes.string.isRequired,
  };

  render() {
    return (
      <img src={icons[this.props.name]} {..._.omit(this.props, ['src'])} alt={this.props.name || '?'}/>
    );
  }
}

export default Icon;



// WEBPACK FOOTER //
// ./src/components/Common/Icon/index.js